import { attr, BaseModel } from "../../lib/itn-ui-kit/data";
///This is temporary...need to fix provider types needed to be an object without breaking the rest of the app
export default class AppointmentAltModel extends BaseModel {
  static urlPath = "appointments";

  @attr("number") pk;
  @attr("datetime") createdAt;
  @attr("datetime") updatedAt;
  @attr("json") client;
  @attr("json") provider;
  @attr("date") appointmentDate;
  @attr("time") appointmentTime;
  @attr("string") status;
  @attr("string") notes;
  @attr("json") providerType;
  @attr("number") documentCount;
  @attr("array") administeredServices;
  @attr("string") runningTotal;
  @attr("json") case;
}
